import { render, staticRenderFns } from "./InventoryResearchForResale.vue?vue&type=template&id=4314c401&scoped=true"
import script from "./InventoryResearchForResale.vue?vue&type=script&lang=js"
export * from "./InventoryResearchForResale.vue?vue&type=script&lang=js"
import style0 from "./InventoryResearchForResale.vue?vue&type=style&index=0&id=4314c401&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4314c401",
  null
  
)

export default component.exports